import base from "./base";
import community from "./community";
import member from "./member";
import stressCare from "./stressCare";
import survey from "./survey";
import youtube from "./youtube";

export default {
    base,
    community,
    member,
    stressCare,
    survey,
    youtube,
};
